// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__1uQfx","loading":"PageLoader_loading__2Uo8c"};